/**
 * Created by JasonChou on 16/5/9.
 */
import Promise from './promise'
import wx from './wxjssdk'
import http from './http'

let wxready = false;

if (agent.isWechat) {
  !function () {
    var wxUrl = encodeURIComponent(location.href.split('#')[0]);
    http.get({
      url: api + 'wx/jsSDKTicket',
      data: {
        url: wxUrl
      },
      jsonp: true
    }).then(function (obj) {
      var appId = obj.data.app_id,
        timestamp = obj.data.timestamp,
        nonceStr = obj.data.noncestr,
        signature = obj.data.signature;
      wx.config({
        appId: appId,
        timestamp: timestamp,
        nonceStr: nonceStr,
        signature: signature,
        jsApiList: [
          'onMenuShareTimeline',
          'onMenuShareAppMessage',
          'hideAllNonBaseMenuItem',
          'showAllNonBaseMenuItem',
          'showOptionMenu',
          'showMenuItems',
          'chooseImage',
          'hideMenuItems',
          'uploadImage',
          'previewImage'
        ]
      });
      wx.ready(function () {
        mod.check.resolve();
      })
    })
  }();
}

wx.ready(function () {
  wxready = true;
  if (typeof cb == 'function') cb();
});

const mod = {
  ready(callback) {
    if (wxready) {
      callback();
    } else {
      cb = callback;
    }
  },

  init() {
    wx.hideAllNonBaseMenuItem();
    wx.showMenuItems({
      menuList: [
        'menuItem:share:appMessage',
        'menuItem:share:timeline',
        'menuItem:favorite'
      ] // 要显示的菜单项，所有menu项见附录3
    });

    const shareData = {
      title: '纹身大咖器材商城',
      desc: '厂商入驻、原装进口、品质有保障。',
      link: location.protocol + '//qicai.wenshendaka.com',
      imgUrl: location.protocol + '//qicai.wenshendaka.com/static/img/share_icon.jpg'
    };

    wx.onMenuShareAppMessage(shareData);
    wx.onMenuShareTimeline(shareData);
  },

  shareAllow: function () {

  },

  closeAll: function () {
    wx.hideOptionMenu();
    wx.hideAllNonBaseMenuItem();
  },
  setShareParams: function (shareData) {
    wx.onMenuShareAppMessage(shareData);
    wx.onMenuShareTimeline(shareData);
  },

  uploadImage: function (params) {
    wx.uploadImage(params);
  },

  chooseImage: function (success) {
    wx.chooseImage({success});
  },

  previewImage: function (params) {
    wx.previewImage(params);
  },

  check: new Promise()
};

mod.check.done(function () {
  mod.init();
});

export default mod



// WEBPACK FOOTER //
// ./src/libs/wx.js